<script lang="ts">
import { defineBlock } from '@bagelink/blox'
import { $, defineSchema } from '@bagelink/vue'
const schema = defineSchema({
	title: $.text('Title'),
})
export const BlockLatestEssays = defineBlock({
	thumbnail: '/block-thumbs/BlockArticleList.svg',
	category: 'Listings',
	order: 115,
	name: 'BlockLatestEssays',
	label: 'Latest Essays',
	icon: 'newspaper',
	schema,
	defaults: { title: 'Latest Essays' },
	dataSource: { collection: 'articles', store: 'the_torah', label: 'Articles' },
})
</script>
<script setup lang="ts">
import { computed } from 'vue'

import { Skeleton } from '@bagelink/vue'
import BlockArticleList from '@/components/blocks/BlockArticleList.vue'
import { useArticlesWithAuthors, ensureAuthors } from '@/composables/useDatastore'



const props = withDefaults(defineProps<{ title?: string }>(), {
	title: 'Latest Essays',
})

ensureAuthors()
const { articles, loading } = useArticlesWithAuthors({
	limit: 200,
	pick: [
		'id',
		'_id',
		'slug',
		'title',
		'teaser',
		'image',
		'publishDate',
		'authorId',
		'secondAuthorId',
		'thirdAuthorId',
		'authorIds',
		'authors',
	],
})

const latestArticles = computed(() =>
	[...articles.value]
		.sort(
			(a: any, b: any) =>
				new Date(b.publishDate || 0).getTime() - new Date(a.publishDate || 0).getTime(),
		)
		.map((article: any) => ({
			title: article.title || '',
			subtitle: article.teaser || '',
			image: article.image || '/og.jpg',
			link: article.link || `/article/${article.slug}`,
			authors: article.authors || [],
		})),
)
</script>

<template>
	<section class="pt-4 pb-3 m_pt-2 m_pb-2">
		<h1
			class="w720px mx-auto txt29 semi line-height-11 balance pb-2 m_px-1 m_txt32 m_line-height-12 m_txt-center"
		>
			{{ props.title }}
		</h1>

		<div
			v-if="loading"
			class="w1000px flex py-2 m_pt-05"
			aria-label="Loading latest essays"
			aria-busy="true"
		>
			<div class="w720px mx-auto display-flex column gap-3">
				<div v-for="article in 6" :key="article" class="display-flex gap-1 align-items-start">
					<Skeleton class="aspect-ratio-4-3 h-110px flex-shrink-0 mb-0 m_h60px" />
					<div class="flex-grow min-w-0">
						<Skeleton width="92%" height="20px" class="mb-05" />
						<Skeleton width="58%" height="20px" class="mb-05" />
						<Skeleton width="100%" height="15px" class="mb-025" />
						<Skeleton width="70%" height="15px" class="mb-075" />
						<Skeleton width="34%" height="14px" class="mb-0" />
					</div>
				</div>
			</div>
		</div>

		<BlockArticleList
			v-else
			:articles="latestArticles"
			show-topics="false"
			class="m_px-1"
			show-authors="true"
		/>
	</section>
</template>
